import { render, staticRenderFns } from "./ShippingMethodDelivery.vue?vue&type=template&id=e93c848a&"
import script from "./ShippingMethodDelivery.vue?vue&type=script&lang=js&"
export * from "./ShippingMethodDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports